import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

Vue.use(Vuex);

const state = {
  // New Variable
  ofcTree: {
    gridOptions: null,
  },
  userInfo: {
    loginYn: false,
    id: null,
    name: null,
    auth: null,
  },
  // Old Variable
  userId: "",
  errorState: "",
  isAuth: false,
  sidebar: "sidebar-hidden",
  userPageAuth: {
    read: true,
    write: true,
    partWrite: true,
  },
  routerInfo: {
    curPath: null,
  },
  webSocket: null,
  webSocketMsg: null,
  centerBus: new Vue(),
  pageMoveParams: null,
  ttDataRefreshYn: false,
  notifyModal: {
    ref: null,
    title: null,
    content: null,
    alertYn: true,
    funcName: null,
  },
  alertOptions: {
    id: "alertBModal",
    title: "알림",
    okTitle: "확인",
    hideHeaderClose: true,
    noCloseOnBackdrop: true,
    noCloseOnEsc: true,
    centered: true,
  },
  confirmOptions: {
    id: "confirmBModal",
    title: "Confirm",
    okTitle: "확인",
    cancelTitle: "취소",
    hideHeaderClose: true,
    noCloseOnBackdrop: true,
    noCloseOnEsc: true,
    centered: true,
  },
  loaderOn: false,
  windowsize: {
    width: 0,
    height: 0,
  },
  selectedData: {
    projectid: null,
    stid: null,
    startDate: null,
    endDate: null,
  },
};

export const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
});



// WEBPACK FOOTER //
// ./src/vuex/store.js